<template>
    <div class="integralruleindex">
        <div class="top">  
           <el-button type="primary" size="medium" @click="integralruleadd()">新增规则</el-button>            
        </div>	
        <el-table stripe :data="dataList"  :height="`${windowHeight-220}px`" border style="width: 100%" >
             <el-table-column  label="名称" show-overflow-tooltip  >
                <template slot-scope="scope">
                    {{scope.row.sceneName}}                   
                </template>
            </el-table-column>  
             <el-table-column label="编码" align="center">
                <template slot-scope="scope">
                        {{scope.row.sceneCode}}
                </template>
            </el-table-column> 
            <el-table-column label="分值" align="center">
                <template slot-scope="scope">
                        {{scope.row.eachScore}}
                </template>
            </el-table-column>   
            <el-table-column label="限制方式" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                       <span v-if="scope.row.limitType==1">无限制</span>
                       <span v-if="scope.row.limitType==2">按日</span>
                       <span v-if="scope.row.limitType==3">按次</span>
                </template>
            </el-table-column> 
            <el-table-column label="限制内容" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                       <span v-if="scope.row.limitType==1">----</span>
                       <span v-if="scope.row.limitType==2">每日上限{{scope.row.limitDailyScore}}</span>
                       <span v-if="scope.row.limitType==3">上限次数{{scope.row.limitDailyScore}}</span>
                </template>
            </el-table-column> 
            <el-table-column label="备注" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                       {{scope.row.remark?scope.row.remark:"----"}}
                </template>
            </el-table-column> 
              <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                         <el-button  @click.native.prevent="integralruleeidt(scope.row.id)"  type="text" size="small">编辑</el-button>
                         <el-button  @click.native.prevent="delABCPointRuleByIds(scope.row.id)"  type="text" size="small">删除</el-button>
                    </template>
            </el-table-column> 
        </el-table>
        <el-pagination
            class="pagination-container"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.pageNo"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</template>
<script>
    import {getABCPointRuleForPage,delABCPointRuleById} from '@/api/integralrule';
    import mixin from '@/mixins/windowResize';
    export default {
        data() {
            return {
                listQuery: {
                    pageNo: 1,
                    pageSize: 20
                },
                dataList: [],
                total: null               
            }
        },
        created() {
            this.queryFoodLists();
        },
        mixins: [mixin],       
        methods: {    
            delABCPointRuleByIds(id){
               this.$confirm('是否删除?', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delABCPointRuleById(id).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.queryFoodLists();
                    }).catch();

                }).catch(() => {
                });
            },    
            //获取列表          
            queryFoodLists() {
                getABCPointRuleForPage(this.listQuery)
                    .then(res => res.data)
                    .then(data => {
                        this.dataList = data.data.dataList;
                        this.total = data.data.pagination.total;
                    }).catch(err => {
                })
            },
            //搜索
            handleFilter (){
                this.listQuery.pageNo=1;
                this.queryFoodLists();
            }, 
            //切换码数          
            handleSizeChange(val) {
                this.listQuery.pageNo=1;
                this.listQuery.pageSize = val;
                this.queryFoodLists();
            },
            //切换页数
            handleCurrentChange(val) {
                this.listQuery.pageNo = val;
                this.queryFoodLists();
            },
            //编辑
            integralruleeidt(id){
                this.$router.push({
                    path: "integralruleeidt",
                    query:{
                        id:id
                    }
                });
            }, 
            //新增
            integralruleadd(){
                this.$router.push({
                    path: "integralruleadd"
                });
            },    
        }
    }
</script>
<style lang="scss" scoped>
.integralruleindex{
   padding:12px;
    .pagination-container {
        margin-top: 10px;
    }
    .top{
        padding-bottom: 10px;
        overflow: hidden;
    }
    .link-type{
            cursor: pointer;
            color: #409eff;
    }
    .top-box{
        width: 100%;
        height: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/integralrule/integralruleindex.vue